// Lib
import { ComponentProps } from 'lib/component-props';

export type AccordionListProps = ComponentProps;

const IngredientAccordion = (): JSX.Element => {
  return (
    <div>
      <h2>Ingredient Information</h2>
    </div>
  );
};
export default IngredientAccordion;
